/**
 * Firebase Web SDK Configuration
 *
 * This file initializes the Firebase app with configuration from environment variables.
 * Get your Firebase config from: Firebase Console > Project Settings > General > Your apps
 */

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Validate required config
if (!firebaseConfig.projectId) {
  throw new Error(
    'Firebase configuration is missing. Please create packages/web/.env file from .env.example'
  );
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Note: Using dev Firebase instance directly (not emulators)
// This simplifies local development and testing
if (import.meta.env.DEV) {
  console.log('🔥 Connected to Firebase dev instance: productworkshop-dev');
}

export default app;
